import { NgModule } from '@angular/core';
import { StorageUrlPipe } from './storage-url/storage-url';
@NgModule({
	declarations: [StorageUrlPipe],
	imports: [],
	exports: [StorageUrlPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts